"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.delete.confirm.title': 'Delete Onboarding',
    'onboarding.delete.confirm.message': 'Are you sure you want to delete this onboarding session?',
};
